import React from 'react';
import AuthService from "../../service/AuthService"
import AccountActions from "./AccountActions";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ResponsiveDrawer from "./DrawerActions"
import proxelera from "../../images/proxelera.png";
import { makeStyles, styled } from '@mui/styles';
import { SERVER_URL, WEB_URL } from '../../constants/urlConstants';
import MenuIcon from '@mui/icons-material/Menu';
import TopDrawer from './Drawer';
import { customStyles } from '../../styles/tableStyle';
const { AppBar, Toolbar, Typography, Grid2, Button, IconButton } = require("@mui/material")
const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1
    },
    menuButton: {
        //marginRight: theme.spacing(2),

    },
    title: {
        flexGrow: 1
    },
    appBarTitle: {
        //f1b10e
        flexGrow: 1,
        backgroundColor: "#f2f2f200",
        backgroundImage: "linear-gradient(230deg, #f2f2f200 75%, #f1b10e 35%)",
        textAlign: "left",
        color: "black",
        fontSize: 16,
        fontWeight: "bold",
        padding: 5,

    }
}));

export default function TopAppBar(props) {
    const classes = useStyles();
    let [menuIndex, setMenuIndex] = React.useState(0)
    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const toggleDrawer = (newOpen) => () => {
        setDrawerOpen(newOpen);
    };
    // let userId = AuthService.getUserId();

    const handleImageClick = (e) => {
        window.location.href = WEB_URL;
    };
    return (
        <Grid2 container spacing={2} direction="row" size={{ md: 12 }} style={{ background: "#6082B6" }}>
            <Grid2 size={{ md: 3 }} style={{ display: 'flex', justifyContent: 'left' }}>
                <div
                    style={{
                        display: "flex",
                        margin: 2,
                        padding: 5,
                        height: '50px',
                        display: "flex",
                        justifyContent: "left",
                        overflow: "hidden"
                    }}
                >
                    {/* <img src={proxelera} onClick={(e) => handleImageClick(e)} /> */}
                </div>
                {AuthService.getUserInfo().role != "user" ? <>
                    <IconButton>
                        <MenuIcon onClick={toggleDrawer(true)} sx={customStyles.actionIcon}></MenuIcon>
                    </IconButton>
                    <TopDrawer toggleDrawer={toggleDrawer} open={drawerOpen} />
                </> : false}

            </Grid2>
            <Grid2 size={{ md: 6 }}>
                <div style={{ padding: '20px', font: '20xp', color: 'white', fontWeight: 'bold' }}>Reg-Magic</div>
            </Grid2>
            <Grid2 size={{ md: 3 }} direction="row" display={"flex"} sx={{
                justifyContent: "center",
                alignItems: "flex-end",
            }}>
                <AccountActions />
            </Grid2>
        </Grid2>
    );
}
